import {createProjectModel} from 'crm/utils/project-model'
import {fissionStatByDate, fissionStatSummary} from '../../services'

const model = createProjectModel({
    projectNamespace: 'customerFission',

    state: {
        tableData: null,
        summaryData: {},
    },

    effects: {
        *fissionStat(xx, {call, select, put, all}) {
            const {tableData} = yield select((allState) => allState[model.namespace])

            const newParams = {
                offset: tableData.pagination.pageSize * (tableData.pagination.current - 1),
                limit: tableData.pagination.pageSize,
                ...tableData.params,
            }

            newParams.date_from = newParams.time[0] ? `${newParams.time[0]}` : ''
            newParams.date_to = newParams.time[1] ? `${newParams.time[1]}` : ''

            const summaryParams = {
                user_id: newParams.user_id,
                date_from: newParams.date_from,
                date_to: newParams.date_to,
            }

            const [fissionStatSummaryRes, fissionStatByDateRes] = yield all([
                call(fissionStatSummary, summaryParams),
                call(fissionStatByDate, newParams),
            ])

            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.summaryData = fissionStatSummaryRes.data
                    draft.tableData.dataSource = fissionStatByDateRes.data
                    draft.tableData.pagination.total =
                        fissionStatByDateRes?.pagination?.rows_found ?? 0
                },
            })
        },
    },
})

export default model
